/**
 * 此檔案是用來管理後端定義的 enum
 */

/** @typedef {'NONE' | 'RECEIPT' | 'INSPECT' | 'EXCEPTION'} ClubStockDocumentTypeKey */
/**
 * @type {Record<ClubStockDocumentTypeKey, number>}
 * @description 店舖庫存單據類型 - 對應後端 ClubStockDocumentTypeEnum（單據類型：0無 1進貨單 2驗收單 3異常單）
 */
export const CLUB_STOCK_DOCUMENT_TYPE = Object.freeze({
	NONE    : 0,   // 無
	RECEIPT : 1,   // 進貨單
	INSPECT : 2,   // 驗收單
	EXCEPTION: 3,  // 異常單
});

/** @typedef {"CUSTOMER" | "MEMBER" | "INVALIDMEMBER" | "TRANSFERMEMBER" | "GUEST" | "ALLMEMBER" | "ONLYJOIN" | "FACUSTOMER" | "CUSTOMERANDGUEST" | "TRANSFERINMEMBER" | "TRANSFERMANUALLY" | "WITHOUTMEMBER" | "TRANSFERTEMPORARY" | "ALREADYTRANSFERINMEMBER" | "CUSTOMERANDALLMEMBER" | "UNCONFIRMTRANSFEROUTMEMBER" | "ALREADYTRANSFEROUTMEMBER" | "ALLREWARDMEMBER" | "USABLEREWARDMEMBER" | "ALLDEVICEORDERMEMBER" | "USABLEDEVICEORDERMEMBER" | "ALLMEMBERFORDEVICEORDER" } PeopleTypeKey */
/**
 * @type {Record<PeopleTypeKey, number>}
 * @description 店鋪會員分類
 *
 */
export const PEOPLE_TYPE = Object.freeze({
	CUSTOMER                  : 1,    // 顧客
	MEMBER                    : 2,    // 會員
	INVALIDMEMBER             : 3,    // 無效會員
	TRANSFERMEMBER            : 4,    // 承接會員
	GUEST                     : 5,    // 名單
	ALLMEMBER                 : 6,    // 全會員
	ONLYJOIN                  : 7,    // 新入會
	FACUSTOMER                : 8,    // FA顧客
	CUSTOMERANDGUEST          : 9,    // 顧客+名單
	TRANSFERINMEMBER          : 10,   // 移入會員
	TRANSFERMANUALLY          : 11,   // 手動移入
	WITHOUTMEMBER             : 12,   // 顧客+名單+無效會員
	TRANSFERTEMPORARY         : 13,   // 未完成移入
	ALREADYTRANSFERINMEMBER   : 14,   // 已移入會員
	CUSTOMERANDALLMEMBER      : 15,   // 顧客+全會員
	UNCONFIRMTRANSFEROUTMEMBER: 16,   // 待確認移出會員
	ALREADYTRANSFEROUTMEMBER  : 17,   // 已移出會員
	ALLREWARDMEMBER           : 51,   // 全點數會員
	USABLEREWARDMEMBER        : 52,   // 可用點數會員
	ALLDEVICEORDERMEMBER      : 53,   // 租用過智能系統會員
	USABLEDEVICEORDERMEMBER   : 54,   // 智能系統租用中會員
	ALLMEMBERFORDEVICEORDER   : 55,   // 可租用智能系統的會員
});

/** @typedef {'MEMBER' | 'NONMEMBER' | 'CROSSMEMBER' | 'COACH' | 'CLUB' | 'HEADQUARTER'} ReceiverType */
/**
 * @type {Record<ReceiverType, number>}
 * @description 接收者類型
 */
export const RECEIVER_TYPE = Object.freeze({
	MEMBER     : 1,   // 會員
	NONMEMBER  : 2,   // 非會員
	CROSSMEMBER: 3,   // 跨店會員
	COACH      : 4,   // 教練
	CLUB       : 5,   // 店舖
	HEADQUARTER: 6    // 總部
});

/** @typedef {'FA' | 'CUSTOMERFWO' | 'CUSTOMER2WO' | 'CUSTOMER3WO' | 'MEMBERFWO' | 'MEMBER2WO' | 'MEMBER3WO' | 'MEMBER4WO' | 'MEMBER5WO' | 'ADVANCEDWO' | 'REPRATISE' | 'STRETCHER' | 'LEAVE' | 'QUIT' | 'MEASURE' | 'TWICEWEEK' | 'RENEW' | 'DIARY' | 'HC' | 'HCLECTURE' | 'CLUBVISIT' | 'OTHER' | 'INVALIDMEMBERFA'} AppointmentType */
/**
 * @type {Record<AppointmentType, number>}
 * @description 預約類型
 */
export const APPOINTMENT_TYPE = Object.freeze({
	FA             : 1,     //FA
	CUSTOMERFWO    : 2,     //FWO
	CUSTOMER2WO    : 3,     //2WO
	CUSTOMER3WO    : 4,     //3WO
	MEMBERFWO      : 101,   //FWO
	MEMBER2WO      : 102,   //2WO
	MEMBER3WO      : 103,   //3WO
	MEMBER4WO      : 104,   //4WO
	MEMBER5WO      : 105,   //5WO
	ADVANCEDWO     : 106,   //進階
	REPRATISE      : 107,   //複習
	STRETCHER      : 108,   //伸展機
	LEAVE          : 201,   //請假
	QUIT           : 202,   //退會
	MEASURE        : 203,   //量身
	TWICEWEEK      : 204,   //二週
	RENEW          : 205,   //續約
	DIARY          : 206,   //營養日記
	HC             : 301,   //HC
	HCLECTURE      : 302,   //HC-講座
	CLUBVISIT      : 303,   //店內參觀
	OTHER          : 304,   //其他
	INVALIDMEMBERFA: 305    //FA
});

/** @typedef {'ALLOWANCE' | 'WAITEDTOALLOWANCE' | 'ALLOWANCEEXCEPTION' | 'INVALIDALLOWANCE' | 'WAITEDTOINVALIDALLOWANCE' | 'INVALIDALLOWANCEEXCEPTION'} InvoiceAllowanceType */
/**
 * @type {Record<InvoiceAllowanceType, number>}
 * @description 發票折讓類型
 */
export const INVOICE_ALLOWANCE_TYPE = Object.freeze({
	ALLOWANCE                : 1,    //已折讓
	WAITEDTOALLOWANCE        : 2,    //等待折讓
	ALLOWANCEEXCEPTION       : 9,    //折讓失敗
	INVALIDALLOWANCE         : 11,   //已作廢折讓
	WAITEDTOINVALIDALLOWANCE : 12,   //等待作廢折讓
	INVALIDALLOWANCEEXCEPTION: 19    //作廢折讓失敗
});

/** @typedef {'ALL' | 'INVOICE_ALLOWANCE' | 'UNPROCESS_BY_TUI_INVOICE' | 'PROCESSING_BY_TUI_INVOICE' | 'UNCONFIRM_BY_TUI_INVOICE'} AllowanceStatusKey */
/**
 * @type {Record<AllowanceStatusKey, number>}
 * @description 三聯式發票折讓總覽 AllowanceStatus（對應後端 OrderIntegrateStatusEnum；TriplicateAllowancePaginationRequestModel.AllowanceStatus；與 api/invoice-allowance/triplicate-uniform/overview/options 選項一致）
 */
export const ALLOWANCE_STATUS = Object.freeze({
	ALL                      : 99,   // 全部
	INVOICE_ALLOWANCE        : 81,   // 發票已折讓
	UNPROCESS_BY_TUI_INVOICE : 101,  // 三聯折讓未處理
	PROCESSING_BY_TUI_INVOICE: 102,  // 三聯折讓處理中
	UNCONFIRM_BY_TUI_INVOICE : 103,  // 待總部確認
});

/** @typedef {'CONFIRM' | 'CALLEDNOTRESPONSE' | 'PHONEERROR'} ContactResultType */
/**
 * @type {Record<ContactResultType, number>}
 * @description 聯絡結果類型
 */
export const CONTACT_RESULT_TYPE = Object.freeze({
	CONFIRM          : 1,   //已確認
	CALLEDNOTRESPONSE: 2,   //已打未接
	PHONEERROR       : 3    //電話錯誤
});

/** @typedef {'CUSTOMER' | 'MEMBER' | 'GUEST' | 'EMPLOYEE' | 'OWNER'} MeasureReferenceType */
/**
 * @type {Record<MeasureReferenceType, number>}
 * @description 量測對象類型
 */
export const MEASURE_REFERENCE_TYPE = Object.freeze({
	CUSTOMER: 1,   //顧客
	MEMBER  : 2,   //會員
	GUEST   : 3,   //訪客
	EMPLOYEE: 4,   //教練
	OWNER   : 5    //加盟主
});

/** @typedef {'CREDITCARDVALIDORDER' | 'ANNUALEFFECTIVEORDER' | 'PAUSEORDER' | 'UNSUBSCRIBEORDER' | 'MOVEOUTORDER' | 'DRAFT' | 'NOTASSIGNORDER' | 'ALL'} CycleOrderType */
/**
 * @type {Record<CycleOrderType, number>}
 * @description 循環訂單類型
 */
export const CYCLEORDER_TYPE = Object.freeze({
	CREDITCARDVALIDORDER: 1,   //信用卡有效訂單
	ANNUALEFFECTIVEORDER: 2,   //年繳有效訂單
	PAUSEORDER          : 3,   //暫停訂單
	UNSUBSCRIBEORDER    : 4,   //退訂訂單
	MOVEOUTORDER        : 5,   //移出訂單
	DRAFT               : 8,   //草稿
	NOTASSIGNORDER      : 9,   //未歸類訂單
	ALL                 : 99   //全部
});

/** @typedef {'XFACTOR' | 'AGREED' | 'GUIDANCE' | 'MEMO' | 'SPECIALCONDITION' | 'PAYMENTMENO' | 'SPECIALBODYCONDITION'} MemberNoteType */
/**
 * @type {Record<MemberNoteType, number>}
 * @description 會員備註類型
 */
export const MEMBER_NOTE_TYPE = Object.freeze({
	XFACTOR             : 1,   // 激勵因子項目來源
	AGREED              : 2,   // 約定項目來源
	GUIDANCE            : 3,   // 指導注意
	MEMO                : 4,   // 備註
	SPECIALCONDITION    : 5,   // 特殊狀況
	PAYMENTMENO         : 6,   // 扣款備註
	SPECIALBODYCONDITION: 7    // 特殊身體狀況
});

/** @typedef {'XFACTOR' | 'AGREEDTASK' | 'TODOTASK' | 'SERVICETASK'} MemberTaskType */
/**
 * @type {Record<MemberTaskType, number>}
 * @description 會員任務類型
 */
export const MEMBER_TASK_TYPE = Object.freeze({
	XFACTOR    : 1,    // 激勵因子
	AGREEDTASK : 2,    // 約定項目
	TODOTASK   : 11,   // 待辦事項
	SERVICETASK: 12    // 服銷待辦
});

/** @typedef {'NORMAL' | 'SUSPEND'} MembershipStatus */
/**
 * @type {Record<MembershipStatus, number>}
 * @description 會籍狀態
 */
export const MEMBERSHIP_STATUS = Object.freeze({
	NORMAL : 1,   // 正常
	SUSPEND: 2    // 暫停
});

/** @typedef { 'NONE' | 'NORMAL' | 'RENEW' | 'TRANSFER' | 'EXCHANGE' | 'MOVEIN' | 'MOVEOUT' } MembershipType */
/**
 * @type {Record<MembershipType, number>}
 * @description 會籍方案
 */
export const MEMBERSHIP_TYPE = Object.freeze({
	NONE    : 0,   // 無
	NORMAL  : 1,   // 新約
	RENEW   : 2,   // 續約
	TRANSFER: 3,   // 承接
	EXCHANGE: 4,   // 轉約
	MOVEIN  : 5,   // 轉入
	MOVEOUT : 6,   // 轉出
});

/** @typedef {'HEALTHDECLARATION2017' | 'HEALTHDECLARATION2022' | 'HEALTHDECLARATION2024'} HealthDeclarationContractVersion */
/**
 * @type {Record<HealthDeclarationContractVersion, number>}
 * @description 健康申告書合約版本
 */
export const HEALTHDECLARATION_CONTRACT_VERSIONE = Object.freeze({
	HEALTHDECLARATION2017: 101,   // 2017-09-01 ~ 2024-10-01 健康申告書201709版
	HEALTHDECLARATION2022: 102,   // 2017-09-01 ~ 2024-10-01 健康申告書201709版
	HEALTHDECLARATION2024: 103    // 2024-10-01 ~ 現在 申請書202410版本
});

/** @typedef {'TRANSFERIN' | 'TRANSFEROUT' | 'MEMBERSHIPEXPIRED' | 'INVOICE' | 'DOCUMENT' | 'VERSION' | 'CYCLEPURCHASE' | 'ALL'} NotificationSourceType */
/**
 * @type {Record<NotificationSourceType, number>}
 * @description 通知來源類型
 */
export const NOTIFICATION_SOURCE_TYPE = Object.freeze({
	TRANSFERIN       : 1,   // 會籍移入
	TRANSFEROUT      : 2,   // 會籍移出
	MEMBERSHIPEXPIRED: 3,   // 會籍到期
	INVOICE          : 4,   // 發票異常
	DOCUMENT         : 5,   // 暫存文書
	VERSION          : 6,   // 上版作業
	CYCLEPURCHASE    : 7,   // 循環訂單
	ALL              : 99   // 全部
});

/** @typedef {'ONTHEJOB' | 'RESIGN' | 'FURLOUGH'} EmployeeStatusType */
/**
 * @type {Record<EmployeeStatusType, number>}
 * @description 通知來源類型
 */
export const EMPLOYEE_STATUS_TYPE = Object.freeze({
	ONTHEJOB: 1,   // 在職
	RESIGN  : 2,   // 離職
	FURLOUGH: 3    // 留職停薪
});

/** @typedef {"MEMBERSHIP2017" | "MEMBERSHIP2022" | "Membership202310" | "Membership202501" | "Membership202510"} MembershipContractVersionKey.*/
/**
 * @type {Record<MembershipContractVersionKey, number>}
 * @description “入會申請書”版本代碼對照表，重點是對應 101,102... 這些數字，變數名稱的年月不是準確時間，只能當作參考。
 */
export const MEMBERSHIP_CONTRACT_VERSION = Object.freeze({
	MEMBERSHIP2017  : 101,   // 2017年版申請書，代號101
	MEMBERSHIP2022  : 102,   // 2022年版申請書，代號102
	Membership202310: 103,   // 2023年10月版申請書，代號103
	Membership202501: 104,   // 2025年01月版申請書，代號104
	Membership202510: 105,    // 2025年10月版申請書，代號105
	Membership202610: 106     // 2026年10月版申請書，代號106
});

/** @typedef {"MEMBERCARRIER" | "MOBILEBARCODE" | "CITIZENDIGITALCERTIFICATE" | "SMSSENT" } InvoiceCarrierTypeKey */
/**
 * @type {Record<InvoiceCarrierTypeKey, number>}
 * @description 發票載具類型
 */
// 發票載具類型
export const INVOICE_CARRIER_TYPE = Object.freeze({
	MEMBERCARRIER            : 1,   // 會員載具
	MOBILEBARCODE            : 2,   // 手機條碼載具
	CITIZENDIGITALCERTIFICATE: 3,   // 自然人憑證條碼載具
	SMSSENT                  : 4    // 簡訊寄送
});

/** @typedef {"DONATE" | "DUPLICATEUNIFORMINVOICE" | "TRIPLICATEUNIFORMINVOICE" } InvoiceIssuingTypeKey */
/**
 * @type {Record<InvoiceIssuingTypeKey, number>}
 * @description 文書發票開立方式
 */
// 文書發票開立方式
export const INVOICE_ISSUING_TYPE = Object.freeze({
	DONATE                  : 1,   // 捐贈發票
	DUPLICATEUNIFORMINVOICE : 2,   // 二聯式發票
	TRIPLICATEUNIFORMINVOICE: 3    // 三聯式發票
});

/** @typedef {"DONATE" | "DUPLICATEUNIFORMINVOICE" | "TRIPLICATEUNIFORMINVOICE" | "MANUAL" } OrderInvoiceIssuingTypeKey */
/**
 * @type {Record<OrderInvoiceIssuingTypeKey, number>}
 * @description 訂單發票開立方式
 */
// 訂單發票開立方式
export const ORDER_INVOICE_ISSUING_TYPE = Object.freeze({
	DONATE                  : 1,   // 捐贈發票
	DUPLICATEUNIFORMINVOICE : 2,   // 二聯式發票
	TRIPLICATEUNIFORMINVOICE: 3,   // 三聯式發票
	MANUAL                  : 4,   // 手開發票
});


/** @typedef {'RENTAL' | 'STOP' | 'END' | 'OVERDRAFT' } DeviceOrderFilterStatus */
/**
 * @type {Record<DeviceOrderFilterStatus, number>}
 * @description 智能系統裝置狀態
 */
// 智能系統裝置狀態
export const DEVICE_ORDER_FILTER_STATUS = Object.freeze({
	RENTAL   : 1,   // 有效
	STOP     : 2,   // 暫停
	END      : 3,   // 退訂
	OVERDRAFT: 4,   // 欠費
});

/** @typedef {'CREDITCARD' | 'ACH' | 'CASH' | 'REMIT' } PaymentType */
/**
 * @type {Record<PaymentType, number>}
 * @description 付款方式
 */
// 付款方式
export const PAYMENT_TYPE = Object.freeze({
	CREDITCARD: 1,   // 信用卡自動扣款
	ACH       : 2,   // 銀行自動扣款
	CASH      : 3,   // 現金
	REMIT     : 4,   // 匯款
});

/** @typedef {'NEWSALE' | 'MEMBERSHIP' | 'PRODUCTSALE' | 'HEALTHCARESALE' | 'CABINET' | 'DEVICE' | 'MEMBERSHIPOFFSITE' | 'HEALTHCARESALEOFFSITE' | 'CABINETOFFSITE' | 'OFFSITE' | 'BONUS' | 'DEVICEOFFSITE' } StatisticsFilterType */
/**
 * @type {Record<StatisticsFilterType, number>}
 * @description 付款方式
 */
// 統計查詢類型
export const STATISTICS_FILTER_TYPE = Object.freeze({
	NEWSALE              : 1,    // 新銷售收入
	MEMBERSHIP           : 2,    // 會籍現場收入
	PRODUCTSALE          : 3,    // 商品現場收入
	HEALTHCARESALE       : 4,    // 健康產品現場收入
	CABINET              : 5,    // 租櫃現場收入
	DEVICE               : 6,    // 智能收入
	MEMBERSHIPOFFSITE    : 31,   // 會籍非現場收入
	HEALTHCARESALEOFFSITE: 32,   // 健康產品非現場收入
	CABINETOFFSITE       : 33,   // 租櫃非現場收入
	OFFSITE              : 39,   // 非現場收入
	BONUS                : 51,   // 紅利收入
	DEVICEOFFSITE        : 52    // 智能非現場收入
});

/** @typedef {'MEMBERSHIP' | 'SUSPENSIONS' | 'QUIT' | 'HEALTHDECLARATION' | 'TRANSFER' | 'TRANSFEROUT' | 'TRANSFERIN' | 'CYCLEPURCHASE' | 'CYCLEPURCHASEEFFECTION' | 'DEVICEORDER' | 'DEVICEORDERSUSPEND' | 'DEVICEORDERQUIT' | 'CREDITCARDAUTHORIZATIONLETTER' | 'INTERNATIONALTRANSFER' | 'TRAVELPASS' } SourceType */
/**
 * @type {Record<SourceType, number>}
 * @description 付款方式
 */
// 所有文書對應來源
export const SOURCE_TYPE = Object.freeze({
	MEMBERSHIP                   : 1,    // 會籍入會續約
	SUSPENSIONS                  : 2,    // 暫停
	QUIT                         : 3,    // 退會
	HEALTHDECLARATION            : 4,    // 健康狀態申告書
	TRANSFER                     : 5,    // 轉讓會籍
	TRANSFEROUT                  : 6,    // 移出會籍
	TRANSFERIN                   : 7,    // 移入會籍
	CYCLEPURCHASE                : 21,   // 循環訂單
	CYCLEPURCHASEEFFECTION       : 22,   // 循環變更單
	DEVICEORDER                  : 23,   // 智能系統訂單
	DEVICEORDERSUSPEND           : 24,   // 智能系統暫停申請書
	DEVICEORDERQUIT              : 25,   // 智能系統終止申請書
	CREDITCARDAUTHORIZATIONLETTER: 31,   // 信用卡授權書
	INTERNATIONALTRANSFER        : 51,   // 國外移籍申請書
	TRAVELPASS                   : 52    // 旅行卡
});

/** @typedef {'Membership' | 'Cabinet' | 'CyclePurchase' | 'DeviceOrder'} PaymentSourceType */
/**
 * @type {Record<PaymentSourceType, number>}
 * @description 付款來源類型
 */
export const PAYMENT_SOURCE_TYPE_MAP = Object.freeze({
	MEMBERSHIP   : 1,   // 會籍
	CABINET      : 2,   // 租櫃
	CYCLEPURCHASE: 4,   // 循環訂單
	DEVICEORDER  : 5,   // 智能系統訂單
});

/** @typedef {'INBODY370S' | 'INBODY370' | 'INBODY370_DM_0536'} InbodyModelVersionType */
/**
 * @type {Record<InbodyModelVersionType, number>}
 * @description InBody 電腦Driver版本型號 INBODY370S 型號為最多數
 */
// InBody 電腦Driver版本型號 INBODY370S 型號為最多數
export const INBODY_MODEL_VERSION_TYPE = Object.freeze({
	INBODY370S       : 1,
	INBODY370        : 2,
	INBODY370_DM_0536: 3,
});

/** @typedef {'SUBSCRIBED' | 'SUSPEND' | 'UNSUBSCRIBE' | 'NOSUBSCRIBE' | 'DONOTPUSH'} PushStatusType */
/**
 * @type {Record<PushStatusType, number>}
 * @description 訂單狀態
 */
// 訂單狀態
export const PUSH_STATUS_TYPE = Object.freeze({
	SUBSCRIBED : 1,   // 訂購中
	SUSPEND    : 2,   // 暫停
	UNSUBSCRIBE: 3,   // 退訂
	NOSUBSCRIBE: 4,   // 未訂購
	DONOTPUSH  : 9,   // 永久不推
});

/** @typedef {'VISA' | 'MasterCard' | 'JCB' | 'OTHER'} CreditCardType */
/**
 * @type {Record<CreditCardType, number>}
 * @description 信用卡類型常數定義。
 * - 1 : VISA
 * - 2 : MasterCard
 * - 3 : JCB
 * - 99: 無法辨識或尚未指定 Other
 */
export const CREDIT_CARD_TYPE = Object.freeze({
	VISA      : 1,
	MasterCard: 2,
	JCB       : 3,
	OTHER     : 99,
});

/** @typedef {'JOIN' | 'REFILL' | 'MOVEIN' | 'MOVEOUT' | 'RENEW' | 'EXCHANGED' | 'REJOIN' | 'TRANSFER' | 'TAKEOVER' | 'EXCHANGENEW' | 'SUSPENSION' | 'EPIDEMICPREVENTION' | 'CONTINUEDDEBIT' | 'CLUBBREAK' | 'SUSPENSIONNONDEBIT' | 'CLUBSUSPENSION' | 'FOLLOWINGGIFT' | 'INFRONTGIFT' | 'MANUALGIFT' | 'MANUALEXTENSION' | 'QUIT' | 'INTERNALMOVEOUT' | 'DELAYCONTINUEDMEMBERSHIP' | 'MOVEINSTART' | 'MOVEINRENEW'} MembershipItemType */
/**
 * @type {Record<MembershipItemType, number>}
 * @description 會員項目類型
 */
export const MEMBERSHIP_ITEM_TYPE = Object.freeze({
	JOIN                    : 1,    // 新入會
	REFILL                  : 2,    // 重填
	MOVEIN                  : 3,    // 移入
	MOVEOUT                 : 4,    // 移出
	RENEW                   : 5,    // 續約
	EXCHANGED               : 6,    // 轉約
	REJOIN                  : 7,    // 復會
	TRANSFER                : 8,    // 轉讓
	TAKEOVER                : 9,    // 承接
	EXCHANGENEW             : 10,   // 轉新約
	SUSPENSION              : 11,   // 暫停
	EPIDEMICPREVENTION      : 12,   // 防疫假
	CONTINUEDDEBIT          : 13,   // 持續扣款
	CLUBBREAK               : 14,   // 店休
	SUSPENSIONNONDEBIT      : 15,   // 免扣款暫停
	CLUBSUSPENSION          : 16,   // 店休暫停
	FOLLOWINGGIFT           : 21,   // 贈送
	INFRONTGIFT             : 22,   // 贈送
	MANUALGIFT              : 23,   // 手動贈送
	MANUALEXTENSION         : 24,   // 手動展延
	QUIT                    : 31,   // 退會
	INTERNALMOVEOUT         : 32,   // 國外移籍
	DELAYCONTINUEDMEMBERSHIP: 41,   // 延後會籍
	MOVEINSTART             : 51,   // 新入會
	MOVEINRENEW             : 52,   // 續約
});

/** @typedef { 'NEWSALE' | 'STOREMONTHLYFEE' | 'QUITFEE' | 'HANDINGFEE' | 'STORECABINETFEE' | 'CABINETNEWSALE' | 'TRANSFERFEE' | 'TRANSFERINFEE' | 'DEVICENEWSALE' | 'PRODUCTSALE' | 'HEALTHCARESALE' | 'MONTHLYFEE' | 'CABINETFEE' | 'CYCLEPURCHASE' | 'DEVICEORDER' | 'REMIT' } OrderType */
/**
 * @type {Record<OrderType, number>}
 * @description 訂單類型代碼表（對應各種收入項目）
 */
export const ORDER_TYPE = Object.freeze({
	NEWSALE        : 1,     //新銷售收入
	STOREMONTHLYFEE: 2,     //既存會員月費
	QUITFEE        : 3,     //退會收入
	HANDINGFEE     : 4,     //手續費
	STORECABINETFEE: 5,     //既存租櫃費
	CABINETNEWSALE : 6,     //首月租櫃費
	TRANSFERFEE    : 7,     //轉讓費用
	TRANSFERINFEE  : 8,     //移入費用
	DEVICENEWSALE  : 9,     //智能收入
	PRODUCTSALE    : 11,    //商品收入
	HEALTHCARESALE : 12,    //健康商品收入
	MONTHLYFEE     : 21,    //月費
	CABINETFEE     : 22,    //租櫃
	CYCLEPURCHASE  : 51,    //循環訂單
	DEVICEORDER    : 52,    //智能方案訂單
	REMIT          : 100,   //匯款金額
});

/** @typedef {'JoinFee' | 'FirstMonthFee' | 'NextMonthFee' | 'DeviceFirstMonthFee' | 'TrainingFee' | 'MonthlyFee' | 'CabinetMonthFee' | 'QuitFee' | 'HandingFee' | 'TransferFee' | 'TransferInMonthFee' | 'TransferOutMonthFee' | 'Bonus' | 'SummerActivityFee' | 'InwardProduct' | 'OutwardProduct' | 'InwardHealthcare' | 'OutwardHealthcare' | 'InwardProductStatistics' | 'OutwardProductStatistics' | 'InwardHealthcareStatistics' | 'OutwardHealthcareStatistics' | 'InwardOthers' | 'OutwardOthers'} RevenueType */
/**
 * @type {Record<RevenueType, number>}
 * @description 新增收入類型
 */
export const REVENUE_TYPE = Object.freeze({

	JOINFEE            : 101,   // 入會費
	FIRSTMONTHFEE      : 102,   // 首月月費
	NEXTMONTHFEE       : 103,   // 隔月月費
	DEVICEFIRSTMONTHFEE: 104,   // 智能首月月費
	TRAININGFEE        : 105,   // 開通設定費

	MONTHLYFEE     : 201,   // 既存月費
	CABINETMONTHFEE: 202,   // 既存租櫃月費
	QUITFEE        : 203,   // 退會費用
	HANDINGFEE     : 204,   // 手續費
	TRANSFERFEE    : 205,   // 轉讓手續費

	TRANSFERINMONTHFEE : 251,   // 移入月費(收入)
	TRANSFEROUTMONTHFEE: 261,   // 移出月費(支出)

	BONUS: 301,   // 紅利收入

	SUMMERACTIVITYFEE: 401,   // 夏日女神報名費

	INWARDPRODUCT              : 901,   // 一般商品(收入)
	OUTWARDPRODUCT             : 902,   // 一般商品(支出)
	INWARDHEALTHCARE           : 903,   // 健康產品(收入)
	OUTWARDHEALTHCARE          : 904,   // 健康產品(支出)
	INWARDPRODUCTSTATISTICS    : 905,   // 一般商品(收入，統計至PJ)
	OUTWARDPRODUCTSTATISTICS   : 906,   // 一般商品(支出，統計至PJ)
	INWARDHEALTHCARESTATISTICS : 907,   // 健康產品(收入，統計至PJ)
	OUTWARDHEALTHCARESTATISTICS: 908,   // 健康產品(支出，統計至PJ)

	INWARDOTHERS : 951,   // 其他(收入)
	OUTWARDOTHERS: 952,   // 其他(支出)
});

/** @typedef { 'NONE' | 'STRATEGICPARTNER' | 'SELFCLUBSOCIAL' | 'NETWORK' | 'EXISTINGLIST' | 'CP' | 'PRINTMEDIA' | 'LETTERBOXFLYER' | 'SELFCLUBBR' | 'HANDOUTFLYER' | 'OTHERCLUBBR' | 'BRLIST' | 'BILLBOARD' | 'CPCALLOUT' | 'GPLIST' | 'OTHER' | 'ALL' } PeopleSourceType */
/**
 * @type {Record<PeopleSourceType, number>}
 * @description 顧客來源
 */
export const PEOPLE_SOURCE_TYPE = Object.freeze({
	NONE            : 0,     //無
	STRATEGICPARTNER: 1,     //策略夥伴
	SELFCLUBSOCIAL  : 2,     //自店社群
	NETWORK         : 3,     //網路
	EXISTINGLIST    : 4,     //既有名單
	CP              : 5,     //CP
	PRINTMEDIA      : 6,     //平面媒體
	LETTERBOXFLYER  : 7,     //信箱傳單
	SELFCLUBBR      : 8,     //自店BR
	HANDOUTFLYER    : 9,     //手發傳單
	OTHERCLUBBR     : 10,    //他店BR
	BRLIST          : 11,    //BR名單
	BILLBOARD       : 12,    //招牌
	CPCALLOUT       : 13,    //CP去電
	GPLIST          : 14,    //GP名單
	OTHER           : 99,    //其他
	ALL             : 999,   //全部
});

/**
 * @typedef {'ITEMS' | 'SHIPPINGDAY' | 'RECEIVER' | 'PAYMENT' | 'STOP' | 'QUIT' | 'RESTOP' | 'INVOICE'} EffectContentType
 */
/**
 * @type {Record<EffectContentType, number>}
 * @description HC 循環邊更單變更項目
 */
export const EFFECT_CONTENT_TYPE = Object.freeze({
	ITEMS      : 2 ** 0,   // 1 商品口味數量
	SHIPPINGDAY: 2 ** 1,   // 2 出貨週期
	RECEIVER   : 2 ** 2,   // 4 收件資訊
	PAYMENT    : 2 ** 3,   // 8 付款資訊
	STOP       : 2 ** 4,   // 16 暫停
	QUIT       : 2 ** 5,   // 32 退訂
	RESTOP     : 2 ** 6,   // 64 回復暫停
	INVOICE    : 2 ** 7,   // 128 發票資訊
	CHANGEITEMS: 2 ** 8,   // 256 商品口味數量(會員)
});

/** @typedef {'NONE' | 'VALID' | 'END' | 'DELETED'} EffectStatusKey */
/**
 * @type {Record<EffectStatusKey, number>}
 * @description HC 循環變更單生效狀態
 */
export const EFFECT_STATUS = Object.freeze({
	NONE   : 0,   // 未生效
	VALID  : 1,   // 生效中
	END    : 2,   // 已結束
	DELETED: 9,   // 已刪除
});

/** @typedef { 'MEMBER' | 'EMPLOYEE' } MemberSiteLogonType */
/**
 * @type {Record<MemberSiteLogonType, number>}
 * @description 會員網站登入類型
 * */
export const MEMBER_SITE_LOGON_TYPE = Object.freeze({
	MEMBER  : 1,   // 會員
	EMPLOYEE: 2,   // 教練
});


/** @typedef {'NONE' | 'BEFORE' | 'AFTER' | 'PRESUBSCRIPTION'} PromotionalPlanFreeType */
/**
 * @type {Record<PromotionalPlanFreeType, number>}
 * @description 行銷方案贈送類型
 */
export const PROMOTIONAL_PLAN_FREE_TYPE = Object.freeze({
	NONE           : 0,   // 無
	BEFORE         : 1,   // 會籍前
	AFTER          : 2,   // 會籍後
	PRESUBSCRIPTION: 3,   // 訂閱前
});

/** @typedef {'NONE' | 'NOTMATCHTIME' | 'EXCHANGECLUB' | 'NOOBVIOUSEFFECT' | 'UNPAID' | 'FAMILYCARE' | 'NOTEXERCISE' | 'DOCTORINSTRUCTIONS' | 'FAMILYNOTSUPPORT' | 'RELOCATEWITHNOCURVES' | 'EXPATRIATEWITHNOCURVES' | 'NONRENEWAL' | 'EPIDEMIC' | 'RELOCATION' | 'EXPATRIATE' | 'BREACHRULES' | 'OTHERS'} QuitReasonType */
/**
 * @type {Record<QuitReasonType, number>}
 * @description 退會原因類型
 */
export const QUIT_REASON_TYPE = Object.freeze({
	NONE                  : 0,    // 無
	NOTMATCHTIME          : 1,    // 時間無法搭配
	EXCHANGECLUB          : 2,    // 換不同地方運動
	NOOBVIOUSEFFECT       : 3,    // 無明顯成果
	UNPAID                : 4,    // 未繳費(教練)
	FAMILYCARE            : 5,    // 家庭照護
	NOTEXERCISE           : 6,    // 不想運動
	DOCTORINSTRUCTIONS    : 7,    // 醫生指示不能運動
	FAMILYNOTSUPPORT      : 8,    // 家人不支持
	RELOCATEWITHNOCURVES  : 9,    // 遷居(附近無Curves分店)
	EXPATRIATEWITHNOCURVES: 10,   // 外派(附近無Curves分店)
	NONRENEWAL            : 11,   // 期滿不續約(教練)
	EPIDEMIC              : 12,   // 疫情(COVID-19)
	RELOCATION            : 13,   // 遷居
	EXPATRIATE            : 14,   // 外派
	BREACHRULES           : 15,   // 違反管理規範
	OTHERS                : 99,   // 其他
});

/** @typedef {'MESSAGEISAPPOINTMENT' | 'MESSAGEISSEND' | 'MESSAGECOMPLETED' | 'MESSAGECANCEL' | 'NOTENOUGHP' | 'MESSAGEUNCOMPLETED'} SmsStatusType */
/**
 * @type {Record<SmsStatusType, number>}
 * @description 簡訊狀態
 */
export const SMS_STATUS_TYPE = Object.freeze({
	MESSAGEISAPPOINTMENT: 1,   // 簡訊已預約
	MESSAGEISSEND       : 2,   // 簡訊發送中
	MESSAGECOMPLETED    : 3,   // 簡訊已發送
	MESSAGECANCEL       : 4,   // 簡訊已取消
	NOTENOUGHP          : 5,   // 點數餘額不足
	MESSAGEUNCOMPLETED  : 6    // 逾期未發送
});

/** @typedef {'FEMALE' | 'MALE' } GenderType */
/**
 * @type {Record<GenderType, number>}
 * @description 性別
 */
export const GENDER_TYPE = Object.freeze({
	FEMALE: 1,   // 女
	MALE  : 2,   // 男
});

/** @typedef {'ALL' | 'VALIDLIST' | 'INVALIDLIST'} CustomerValidType */
/**
 * @type {Record<CustomerValidType, number>}
 * @description 顧客總覽有效無效
 */
export const CUSTOMER_VALID_TYPE = Object.freeze({
        ALL        : 1,   //全部
        VALIDLIST  : 2,   //有效名單
        INVALIDLIST: 4,   //無效名單
});

/** @typedef {'GUESTOVERVIEW' | 'CUSTOMEROVERVIEW'} FilterType */
/**
 * @type {Record<FilterType, number>}
 * @description 暫存名單
 */
export const FILTER_TYPE = Object.freeze({
        GUESTOVERVIEW   : 1,   //名單總覽
        CUSTOMEROVERVIEW: 2,   //顧客總覽
});

/** @typedef {'GUEST' | 'CUSTOMER' | 'MEMBER'} CustomerTypeKey */
/** @typedef {1 | 2 | 3} CustomerTypeText */

/**
 * 系統用的顧客類型定義（enum-like）
 * @type {Record<CustomerTypeKey, CustomerTypeText>}
 */
export const CUSTOMER_TYPE = Object.freeze({
	GUEST   : 1,   // 訪客
	CUSTOMER: 2,   // 顧客
	MEMBER  : 3,   // 會員
});

/**
 * @type {Record<number, string>}
 */
export const CUSTOMER_TYPE_TEXT = Object.freeze({
	[CUSTOMER_TYPE.GUEST]   : "訪客",
	[CUSTOMER_TYPE.CUSTOMER]: "顧客",
	[CUSTOMER_TYPE.MEMBER]  : "會員",
});

/** 
 * @typedef {
 *  | 'CUSTOMER'
 *  | 'MEMBER'
 *  | 'INVALIDMEMBER'
 *  | 'TRANSFERMEMBER'
 *  | 'GUEST'
 *  | 'ALLMEMBER'
 *  | 'ONLYJOIN'
 *  | 'FACUSTOMER'
 *  | 'CUSTOMERANDGUEST'
 *  | 'TRANSFERINMEMBER'
 *  | 'TRANSFERMANUALLY'
 *  | 'WITHOUTMEMBER'
 *  | 'TRANSFERTEMPORARY'
 *  | 'ALREADYTRANSFERINMEMBER'
 *  | 'CUSTOMERANDALLMEMBER'
 *  | 'UNCONFIRMTRANSFEROUTMEMBER'
 *  | 'ALREADYTRANSFEROUTMEMBER'
 *  | 'ALLREWARDMEMBER'
 *  | 'USABLEREWARDMEMBER'
 *  | 'ALLDEVICEORDERMEMBER'
 *  | 'USABLEDEVICEORDERMEMBER'
 *  | 'ALLMEMBERFORDEVICEORDER'
 * } TargetTypeKey
 */
/**
 * 目標對象類型列舉（系統 / API / Query 使用）
 * @type {Record<TargetTypeKey, number>}
 */
export const TARGET_TYPE = Object.freeze({
    CUSTOMER                  : 1,    // 顧客
    MEMBER                    : 2,    // 會員
    INVALIDMEMBER             : 3,    // 無效會員
    TRANSFERMEMBER            : 4,    // 承接會員
    GUEST                     : 5,    // 名單
    ALLMEMBER                 : 6,    // 全會員
    ONLYJOIN                  : 7,    // 新入會
    FACUSTOMER                : 8,    // FA顧客
    CUSTOMERANDGUEST          : 9,    // 顧客+名單
    TRANSFERINMEMBER          : 10,   // 移入會員
    TRANSFERMANUALLY          : 11,   // 手動移入
    WITHOUTMEMBER             : 12,   // 顧客+名單+無效會員
    TRANSFERTEMPORARY         : 13,   // 未完成移入
    ALREADYTRANSFERINMEMBER   : 14,   // 已移入會員
    CUSTOMERANDALLMEMBER      : 15,   // 顧客+全會員
    UNCONFIRMTRANSFEROUTMEMBER: 16,   // 待確認移出會員
    ALREADYTRANSFEROUTMEMBER  : 17,   // 已移出會員
    ALLREWARDMEMBER           : 51,   // 全點數會員
    USABLEREWARDMEMBER        : 52,   // 可用點數會員
    ALLDEVICEORDERMEMBER      : 53,   // 租用過智能系統會員
    USABLEDEVICEORDERMEMBER   : 54,   // 智能系統租用中會員
    ALLMEMBERFORDEVICEORDER   : 55    // 可租用智能系統的會員
});

/** @typedef {'Normal' | 'Defective'} OrderReturnWarehouseTypeKey */
/**
 * @type {Record<OrderReturnWarehouseTypeKey, number>}
 * @description 退貨入庫倉庫類型（對應後端 OrderReturnWarehouseTypeEnum）
 */
export const ORDER_RETURN_WAREHOUSE_TYPE = Object.freeze({
    Normal   : 1,   // 一般倉（可販售）
    Defective: 3,   // 瑕疵倉
});

export const ORDER_RETURN_WAREHOUSE_TYPE_OPTIONS = Object.freeze([
    { value: ORDER_RETURN_WAREHOUSE_TYPE.Defective, text: '瑕疵' },
    { value: ORDER_RETURN_WAREHOUSE_TYPE.Normal,    text: '可販售' },
]);
